<template>
	<sa-page-layout :btnBackVisible="false" :btnNewVisible="true" :btnRefreshVisible="true" :linkedit="linkedit" :showModalLoading="showModalLoading" @refresh="onRefresh">
		<template slot="table-body">
			<gestione-attivita-clienti-list-component ref="cmpGestioneAttivitaClientiListComponent" @beforeLoadData="onBeforeLoadDataGestioneAttivitaClientiListComponent" @afterLoadData="onAfterLoadDataGestioneAttivitaClientiListComponent"></gestione-attivita-clienti-list-component>
		</template>
	</sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/layout/components/SaPageLayout.vue";
import GestioneAttivitaClientiListComponent from "../components/GestioneAttivitaClientiListComponent.vue";
export default {
	components: { SaPageLayout, GestioneAttivitaClientiListComponent },
	data() {
		return {
			showModalLoading: false,
			linkedit: "clienti",
		};
	},
	mounted() {
		let me = this;
		me.$refs.cmpGestioneAttivitaClientiListComponent.init();
	},
	methods: {
		onBeforeLoadDataGestioneAttivitaClientiListComponent() {
			let me = this;
			me.showModalLoading = true;
		},
		onAfterLoadDataGestioneAttivitaClientiListComponent() {
			let me = this;
			me.showModalLoading = false;
		},
		onRefresh() {
			let me = this;
			me.$refs.cmpGestioneAttivitaClientiListComponent.init();
		},
	},
};
</script>

<style></style>
